import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { type MethodBaseOptions } from '../types';
import { client } from '../client';

type EpicorInvoice = {
  InvcHead_Company: string;
  InvcHead_InvoiceNum: string;
  InvcHead_TermsCode: string;
  InvcHead_InvoiceDate: string;
  Customer_Name: string;
  OrderHed_OrderNum: string;
  InvcHead_PONum: string;
  Calculated_PONum: string;
  InvcHead_DocInvoiceAmt: number;
  InvcHead_DocInvoiceBal: number;
};

export async function getInvoices(options?: MethodBaseOptions): Promise<EpicorInvoice[]> {
  const { user: userData} = useUserSession();
  if(!userData.value?.epicor_id) return [];

  const apiClient = new AxiosRequestSender(client)
    .setUrl('invoicesList')
    .setMethod('GET')
    .setProps([{customer_id: userData.value?.epicor_id}])
    .send<EpicorInvoice[]>();

  const epicorInvoices = await apiClient;

  return epicorInvoices;
}
